module.exports = __webpack_public_path__ + "img/a.5cb76619.jpg";